@if (afterCallWorkSate$ | async; as afterCallWorkSate) {
  <div class="after-call-work-state">
    <nimbus-user-tp-capacity-button></nimbus-user-tp-capacity-button>
    <span class="after-call-work-state-content">
      @switch (afterCallWorkSate.state) {
        @case (UserInteractionOutcome.InAfterCallWork) {
          {{ TranslationKeys.DutyAcw | translate }}
          <span>{{ afterCallWorkSate.afterCallWorkUntil | dateDifference: (baseDate$ | async) | durationFormat: 'mm:ss' }}</span>
        }
        @case (UserInteractionOutcome.InExtendedAfterCallWork) {
          {{ TranslationKeys.DutyExtendedAcw | translate }}
          <span>{{ afterCallWorkSate.afterCallWorkUntil | dateDifference: (baseDate$ | async) | durationFormat: 'mm:ss' }}</span>
        }
      }
    </span>
    <span class="button-wrapper">
      @if (afterCallWorkSate.afterCallWorkAllowToExtend) {
        <button
          [disabled]="extendDisabled$ | async"
          (click)="
            extend(
              afterCallWorkSate.unifiedConversationId,
              afterCallWorkSate.conversationId,
              afterCallWorkSate.userSessionId,
              afterCallWorkSate.initialModality,
              afterCallWorkSate.channel
            )
          "
          id="btn-extend"
          nimbusPrimaryIconButton
        >
          <i [nimbusIcon]="Icons.CLOCK_ADD" iconWeight="regular"></i>
          <ng-container>
            <nimbus-tooltip [text]="TranslationKeys.GeneralExtend | translate"></nimbus-tooltip>
          </ng-container>
        </button>
      }
      @if (afterCallWorkSate.afterCallWorkAllowToStop) {
        <button
          [disabled]="stopDisabled$ | async"
          (click)="
            stop(
              afterCallWorkSate.unifiedConversationId,
              afterCallWorkSate.conversationId,
              afterCallWorkSate.userSessionId,
              afterCallWorkSate.initialModality,
              afterCallWorkSate.channel
            )
          "
          id="btn-stop"
          nimbusPrimaryIconButton
        >
          <i [nimbusIcon]="Icons.CLOSE" iconWeight="regular"></i>
          <ng-container>
            <nimbus-tooltip [text]="TranslationKeys.GeneralStop | translate"></nimbus-tooltip>
          </ng-container>
        </button>
      }
    </span>
  </div>
}
